module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099T23R7Z.fa840a36.jpg";